
import Moderator from '@/models/bread/Moderator/automation'

export default {
  key:'Automation',
  name:{
    singular:'Automation',
    plural:'Automations',
  },
  parents:[
    //
  ],
  Admin:false,
  Moderator:Moderator,
  Teacher:false,
}